<template>
<div class="dealers-grid">
  <Grid name="filterGridDealer" ref="filterGridDealer" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload" v-bind:databound="dataBound"></Grid>
  <div>
    <b-button v-on:click="addAll()" variant="success">Incluir todos</b-button>
    <b-button variant="danger" v-on:click="excludeAll()">Excluir todos</b-button>
  </div>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import BaseFilter from './BaseFilter'
export default {
  name: 'Dealer',
  extends: BaseFilter,
  components: {
    Grid
  },
  data() {
    return {
      fieldName: 'dealer_id',
      fieldLabel: 'Distribuidor',
      gridRef: 'filterGridDealer',
      preload: [{
        field: 'dealer_so_code',
        api: 'stars/lst/1'
      }, {
        field: 'dealer_st_code',
        api: 'stars/lst/2'
      }, {
        field: 'dealer_cha_code',
        api: 'stars/lst/4'
      }, {
        field: 'dealer_cadv_code',
        api: 'stars/lst/3'
      }],
      schemaModelFields: {},
      url: 'dealers',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        field: 'id',
        title: 'ID',
        width: '200px'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'dealer_type_stats',
        title: 'Tipo',
        width: '120px',
        values: [{
          value: 1,
          text: 'CCSS'
        }, {
          value: 2,
          text: 'Distribuidor'
        }]
      }, {
        field: 'dealer_so_code',
        title: 'SO',
        width: '120px'
      }, {
        field: 'dealer_st_code',
        title: 'ST',
        width: '120px'
      }, {
        field: 'dealer_cadv_code',
        title: 'CADV',
        width: '120px'
      }, {
        field: 'dealer_cha_code',
        title: 'CHA',
        width: '120px'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      tables: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// DealersFilter.vue?0d94f7d6